(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mc-home"] && !Shopify.designMode) return;
  try {
    
  function initializeHomeTabs(root) {
    if (root.dataset.homeInitialized) return;
    root.dataset.homeInitialized = 'true';
    const tabs = [...root.querySelectorAll('[data-tab]')];
    const panels = [...root.querySelectorAll('[data-panel]')];
    function selectTab(tab, focus) {
      tabs.forEach(item => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.panel !== tab.dataset.tab; });
      if (focus) tab.focus();
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectTab(tab, false));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); selectTab(tabs[next], true); }
      });
    });
    root.querySelectorAll('[data-home-flip]').forEach(card => {
      card.addEventListener('click', () => card.setAttribute('aria-pressed', String(card.getAttribute('aria-pressed') !== 'true')));
      card.addEventListener('keydown', event => { if (event.key === 'Escape') card.setAttribute('aria-pressed', 'false'); });
    });
    root.querySelectorAll('[data-home-video-play]').forEach(button => {
      button.addEventListener('click', async () => {
        const video = button.parentElement.querySelector('video');
        video.controls = true;
        try { await video.play(); button.hidden = true; } catch { video.controls = false; }
      });
    });
  }
  document.querySelectorAll('[data-home-section]').forEach(initializeHomeTabs);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-home-section]').forEach(initializeHomeTabs));

  } catch(e) { console.error(e); }
})();
})();
